import { z } from 'zod'

/**
 * @see https://partner.tiktokshop.com/docv2/page/650aa46ebace3e02b75d9afa?external_id=650aa46ebace3e02b75d9afa#Response_Parameters
 */
export const DeliveryOption = z.object({
    id: z.string(),
    name: z.string(),
    type: z.enum(['STANDARD', 'EXPRESS', 'ECONOMY', 'SEND_BY_SELLER']),
    description: z.string(),
    weight_limit: z.optional(
        z.object({
            max_weight: z.number(),
            min_weight: z.number(),
            unit: z.enum(['GRAM', 'POUND']),
        })
    ),
    dimension_limit: z.optional(
        z.object({
            max_height: z.number(),
            max_length: z.number(),
            max_width: z.number(),
            unit: z.enum(['CM', 'INCH']),
        })
    ),
})
export type DeliveryOption = z.infer<typeof DeliveryOption>
